<template>
  <div>
    <span
      :style="
        ' width:30px;height:30px; display:block; background:' + model + ';'
      "
    ></span>
  </div>
</template>

<script>
export default {
  name: "color",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
